var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row pt-4 pb-3"},[_c('h1',{staticClass:"vacancy-title font-weight-light text-dark pr-3"},[_vm._v(" Gebruikersprofiel ")])])}]

export { render, staticRenderFns }